import slugFunc from '@sindresorhus/slugify';

export function slugify(name: string, maxLength = 40): string {
  if (typeof name !== 'string') {
    console.error('Found a strange slugify input', typeof name, name);

    return '';
  }

  return slugFunc((name || '').slice(0, maxLength), {
    customReplacements: [
      ['@', ' at '],
      ['&', ' und '],
    ],
    preserveLeadingUnderscore: true,
  });
}
